<template>
    
    <div class="head-wrap">  
        <header class="header-part">
            <div class="header_bottom">
                <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-4">
                        <a href="#menu" class="menuIcon"><img :src="baseHref+'assets/images/m-menu-svg2.png'" alt /></a>
                        <nav class="mainNav">
                            <div id="menu">
                                <ul>
                                    <li><a href="https://www.edremodel.com/portfolio">Portfolio</a></li>
                                    <li><a href="https://www.edremodel.com/about">About<i class="bi bi-caret-down-fill"></i></a>
                                        <ul class="s_menu">
                                            <li><a href="https://www.edremodel.com/services">Services</a></li>
                                            <li><a href="https://www.edremodel.com/testimonials">Why Us?</a></li>
                                            <li><a href="https://www.edremodel.com/our-process">Our Process</a></li>
                                            <li><a href="https://www.edremodel.com/about-us">About us</a></li>
                                            <li><a href="https://www.edremodel.com/blog">Blog</a></li>
                                            <li><a href="https://www.edremodel.com/home-owners-guide-newsletter">Home Owners Guide Newsletter</a></li>
                                        </ul>
                                    </li>
                                    <li><a href="https://www.edremodel.com/contact">Contact Us</a></li>
                                    <li><router-link to="/">Showroom</router-link></li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    
                    
                    <div class="col-12 col-lg-4">
                        
                        <a href="https://www.edremodel.com" class="logo"><img :src="baseHref+'assets/images/EDR_Logo-blk.png'" alt=""></a>
                    </div>
                    
                    
                    <div class="col-12 col-lg-4 d-flex align-items-center justify-content-end">
                        <div class="top-right-header d-flex align-items-center justify-content-end">
                            <ul class="nav navbar-btn"> 
                                <li class="nav-item-cart"> 
                                    <router-link to="/cart"
                                        type="button"
                                        class="btn btn-primary"><i class="bi bi-cart-fill"></i>
                                        <!-- Cart -->
                                        <span class="cart-number" v-if="cart_items > 0">{{ cart_items }}</span>
                                    </router-link>
                                </li>
                                <li class="nav-item-login" v-if="user">
                                    <button class="btn btn-primary dropdown-toggle" role="button" data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        <img :src="baseHref+'assets/images/user.svg'" alt="" />
                                    </button>

                                    <div class="dropdown">
                                        <ul class="dropdown-menu" v-if="user"> 
                                            <li>
                                                <router-link to="/notification" class="dropdown-item">
                                                    <span class="name">Notifications ({{
                                                        PendingNotification ? PendingNotification : 0
                                                    }})</span>
                                                </router-link>
                                            </li>                                             
                                            <li>
                                                <router-link to="/account" class="dropdown-item">
                                                    <span class="name">My Account</span>
                                                </router-link>
                                            </li>                                            
                                            <li>
                                                <a class="dropdown-item" href="#" @click.prevent="logout()">Log Out</a>
                                            </li>
                                        </ul>
                                    </div>
                                </li> 

                                <li class="nav-item-login " v-if="!user">
                                    <button class="btn btn-primary" role="button" data-bs-toggle="dropdown"
                                        aria-expanded="false">
                                        <!-- <img :src="baseHref+'assets/images/more.svg'" width="18" height="18" alt="" /> -->
                                        <i class="bi bi-three-dots"></i>
                                    </button>

                                    <div class="dropdown">
                                        <ul class="dropdown-menu"> 
                                            <li>
                                                <router-link class="dropdown-item" to="/register">Sign Up Free
                                                </router-link>
                                            </li>                                            
                                            <li>
                                            <router-link class="dropdown-item" to="/login">Login</router-link>
                                        </li> 
                                        </ul>
                                    </div>
                                </li>

                                <!-- <ul class="navbar-nav ml-auto text-center"> 
                                <li class="nav-item nav-language dropdown">
                                    <v-google-translate defaultLanguageCode="en" defaultPageLanguageCode="en" :languages="[
                                        {
                                            code: 'en',
                                            name: 'English',
                                            ename: 'English'
                                        },
                                        {
                                            code: 'es',
                                            name: 'Español',
                                            ename: 'Spanish'
                                        }
                                    ]" />
                                </li>
                                 </ul> -->

                                <li class="nav-item nav-item-toggle">
                                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                        aria-expanded="false" aria-label="Toggle navigation">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <a class="btn btn-secondary" href="https://www.edremodel.com/contact">Contact Us</a>
                    </div>
                </div>


                
                
                
            </div>
            </div>
            
        </header>


    
        
   
        <div class="head-fix"></div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import axios from "axios";
import { EventBus } from "../../store/eventBus";

export default {
    name: "Header",
    data() {
        return {
            baseHref:baseHref,
            headerMenus: '',
            cart_items: 0,
            headerclass: "bgWhite",
            success: null,
            error: null,
            categoryList: [],
            show: false,
            currentMenu: "",
            logoutButton: false,
            allCategory: false,
            not_showroom:true,
            shop_profile:''
            // intCategory:true
        };
    },
    components:{
        Searchbar: () => import('./Searchbar.vue')
    },
    computed: {
        ...mapGetters("auth", ["user"]),
        ...mapGetters("cart", ["projectCart"]),
        ...mapGetters("Common", ["PendingNotification"]),
        ...mapGetters({
            list: "Common/SubCategoryList",
            showroomId: "Common/MyItem",
            showroom: "Common/ShowRoom",
            category: "Common/Category",
            userCheck: "Common/UserLogin"
        })
    },

    mounted() {
        var check = this.checkUserItLogin();
        this.checkUserLogin(check);

        if (this.showroomId.showroom !== "") {
            axios
                .get("/api/visualization/shop_profile", {
                    params: {
                        showroom: this.showroomId.showroom,
                        vsd_id:shop_id,
                    }
                })
                .then(res => {
                    this.shop_profile=res.data.data.profile
                    this.categoryList = res.data.data.category;

                    this.updateMyItem({
                showroom: this.shop_profile.user_id,
                vsd_id:this.shop_profile.vsd_id,
                basic_addon:this.shop_profile.basic_addon.subscription_status,
                custom_addon:this.shop_profile.custom_addon.subscription_status, 
                theme_color:this.shop_profile.theme_color
            });

                })
                .catch(error => {
                    console.log(error);
                });
        }

        function measurementForSideNav() {
            var topOffset = parseInt(
                $("#headerCont")
                    .css("top")
                    .slice(0, -2)
            );
            var root = document.querySelector(":root");
            root.style.setProperty(
                "--headerGap",
                headerHeight + topOffset + "px"
            );
        }
        // let cart_itemsL=localStorage.getItem('cart_item');
        // console.log("=====cart", cart_itemsL);
        // if(cart_itemsL){
        //     cart_itemsL=JSON.parse(cart_itemsL);
        //     this.cart_items = cart_itemsL.length;
        // }

        $("#leftMenuToggler").click(function () {
            $(this).toggleClass("active");
            $("#leftMenus").toggleClass("active");
            measurementForSideNav();
        });

        $(".clickBtn").click(function () {
            const target = $(this).data("target");
            $("#" + target).toggleClass("active");
        });

        const headerHeight = $("#headerCont").outerHeight();
        const orgLogo = $("#headerLogo").attr("src");
        // $(window).scroll(function () {
        //     if ($(this).scrollTop() > headerHeight) {
        //         $('#headerCont').addClass('fixedNav');
        //         $('#headerLogo').attr('src', $('#headerLogo').data('sticky'));
        //     } else if ($(this).scrollTop() <= headerHeight) {
        //         $('#headerCont').removeClass('fixedNav');
        //         $('#headerLogo').attr('src', orgLogo);
        //     }
        // });

        //clicking out side
        $(document).click(function (e) {
            if ($(e.target).is("#leftMenuToggler") === false) {
                $("#leftMenus, #leftMenuToggler").removeClass("active");
            }
            if ($(e.target).is(".clickBtn") === false) {
                $("#him").removeClass("active");
            }
        });

        $(document).ready(function () {
            $(".eo__dropdown__menu .language").click(function () {
                var closestParent = $(this).closest(
                    "div#navbarSupportedContent"
                );
                if (closestParent.length > 0) {
                    $("div#navbarSupportedContent").removeClass("show");
                }
            });

            $(".signUp_dd_menu a").click(function () {
                var closestParent = $(this).closest(
                    "div#navbarSupportedContent"
                );
                if (closestParent.length > 0) {
                    $("div#navbarSupportedContent").removeClass("show");
                }
            });
        });

        $(document).ready(function () {
            var header = $('header');
            var scrollPrev = 0;

            $(window).scroll(function () {
                var scrollCurrent = $(this).scrollTop();

                if (scrollCurrent >= 1) {
                    header.addClass('sticky');
                } else {
                    header.removeClass('sticky');
                }

                scrollPrev = scrollCurrent;
            });
        });
        $(document).ready(function() {
            $(document).on('click', function(event) {
                // Check if the clicked element is within .all-cat
                if ($(event.target).closest('.all-cat').length) {
                // Add class all-cat-activate to .all-cat
                $('.all-cat').addClass('all-cat-activate');
                // Remove class show from all dropdown menus outside .all-cat
                $('.dropdown-menu').not('.all-cat .dropdown-menu').removeClass('show');

                // Add or remove class show only to immediate children of .all-cat
                $('.all-cat > .dropdown-menu').toggleClass('show');
                } else {
                // Remove class all-cat-activate from .all-cat
                $('.all-cat').removeClass('all-cat-activate');
                // Remove class show from .dropdown-menu within .all-cat
                $('.all-cat .dropdown-menu').removeClass('show');
                }
            });
        });

        /********  ********/
        this.check_validUser();
        this.$root.$on("get_profile", text => {
            this.getUserData();
        });

        this.$root.$on("check_verified_User", n => {
            this.check_validUser();
        });




        
var menu = new MmenuLight(document.querySelector("#menu"), "(max-width: 1199px)");

  var navigator = menu.navigation({
    selectedClass: 'Selected',
    slidingSubmenus: true,
    theme: 'dark',
    title: 'Menu'
  });

  var drawer = menu.offcanvas({
    position: 'left'
  });

  //  Open the menu.
  document
    .querySelector('a[href="#menu"]')
    .addEventListener("click", (evnt) => {
      evnt.preventDefault();
      drawer.open();
    });



    $("button.closeBtn, .showPopupBtn").click(function(){
        $(".popupSideBottom").toggleClass("closePopup");
    });




    },
    created() {
        EventBus.$on('cart-updated', this.updateCartItemCount);
        if(localStorage.getItem('cart_id')){
            this.getCartData();
        }
    },

    watch: {
        "$route.params.vsd_id": {
            handler: function(value) {
                if(value){
                    axios
                .get("/api/visualization/shop_profile", {
                    params: {
                        showroom: value
                    }
                })
                .then(res => {
                    this.shop_profile=res.data.data.profile
                    this.categoryList = res.data.data.category;

                    this.updateMyItem({
                        showroom: this.shop_profile.user_id,
                        vsd_id:this.shop_profile.vsd_id,
                        basic_addon:this.shop_profile.basic_addon.subscription_status,
                        custom_addon:this.shop_profile.custom_addon.subscription_status, 
                        theme_color:this.shop_profile.theme_color
                    });

                })
                .catch(error => {
                    console.log(error);
                });
                }
            },
            deep: true,
            immediate: true,
        },
        $route: {
            immediate: true,
            deep:true,
            handler(to, from) {
                
                // if(to.meta.requiresAuth){
                this.check_validUser();
                // }
                //$router.history.current.path
                this.headerclass = to.path == "/" ? "" : "bgWhite";
                var appname = document
                    .getElementById("appname")
                    .getAttribute("content");
                document.title = appname + ": " + to.meta.title || "";
            }
        },

        user: {
            handler: function (newValue) {
                if (newValue) {
                    this.check_validUser();
                }
            },
            deep: true
        },

        projectCart: {
            handler: function (newValue) {
                console.log("here====help",newValue);
                if (newValue && newValue.Project_tans && newValue.Project_tans.length>0) {
                    console.log("inside here",newValue.Project_tans);
                    const totalQuantity =newValue.Project_tans.reduce((acc, item) => acc + item.qty, 0);
                    console.log("totalQuantity",totalQuantity);
                    this.cart_items = totalQuantity;//newValue.Project_tans.length;
                }else{
                    this.cart_items = 0;
                }
                console.log("this.cart_items is",this.cart_items);
                // else{
                //     let cart_itemsL=localStorage.getItem('cart_item');
                //     console.log("=====<>?", cart_itemsL);
                //     if(cart_itemsL){
                //         cart_itemsL=JSON.parse(cart_itemsL);
                //         this.cart_items = cart_itemsL.length;
                //     }
                // }
            },
            deep: true
        }
    },
    beforeCreate() {
        /* axios
            .get("/api/menu_category")
            .then(res => {
                this.headerMenus = res.data.data;
            })
            .catch(error => {
                console.log(error);
            }); */

    },

    methods: {
        ...mapActions("auth", ["sendLogoutRequest", "getUserData"]),
        ...mapActions("Common", [
            "getPendingNotifications",
            "updateCategory",
            "updateBreadcrumb",
            "updateProductCategory",
            "AddProduct",
            "checkUserLogin",
            "setTopProduct"
        ]),
        ...mapActions("cart", ["getCartData","removeCartData"]),
        ...mapActions('Common',['updateMyItem' ]),
        changeAllCat() {
            this.allCategory = this.allCategory ? false : true;
            console.log(this.allCategory);
        },

        fetchCat(subCatName, Cat, type) {

            let parentCatName = Cat.name;


            if(subCatName=="directto"){
            this.updateProductCategory({
                    category_id:Cat.id,
                    category_name:Cat.name,
                })


                this.updateCategory({
                    parent:parentCatName,
                    sub:Cat,
                    type:type,
                    list:Cat.children,
                })

                //return  this.$router.push('/visualize/product');
                window.location.href="/visualize/product"
         }
            var data = {
                showroom: this.showroomId.showroom,
                category: Cat.id
            };

            this.setTopProduct(data);
            var subCat = "";
            window.scrollTo({
                top: 700,
                left: 0,
                behavior: "smooth"
            });

            if (type === "sub-category") {
                subCat = Cat.children.filter(
                    cat => cat.name === subCatName
                );

                this.updateCategory({
                    parent: parentCatName,
                    sub: subCatName,
                    type: type,
                    list: subCat[0].children
                });
                this.updateBreadcrumb({
                    parent: parentCatName,
                    child: subCatName
                });

                if (subCat[0].children.length < 1) {
                    this.updateCategory({
                        parent: parentCatName,
                        sub: "",
                        list: Cat.children,
                        type: type
                    });

                    this.updateProductCategory({
                        category_id: subCat[0].id,
                        category_name: subCat[0].name
                    });
                }
            } else if (type === "sub-category-2") {
            } else if (type === "parent") {
                this.updateCategory({
                    parent: parentCatName,
                    sub: "",
                    list: Cat.children,
                    type: type
                });
                this.updateBreadcrumb({
                    parent: parentCatName,
                    child: subCatName
                });

                if (!Cat.children || Cat.children.length < 1) {
                    this.updateCategory({
                        parent: parentCatName,
                        sub: "",
                        list: [
                            {
                                id: Cat.id,
                                name: Cat.name,
                                parent_id: Cat.parent_id,
                                photo: Cat.photo,
                                resized_photo: Cat.resized_photo,
                                children: []
                            }
                        ],
                        type: type
                    });
                }
            } else {
                this.updateCategory({
                    parent: parentCatName,
                    sub: "",
                    list: this.showroom.category,
                    type: type
                });
                this.updateBreadcrumb({
                    parent: "all",
                    child: ""
                });
            }

            this.updateProductCategory({
                category_id: Cat.id,
                category_name: Cat.name
            });

            var parentCat = parentCatName.toLowerCase();
            var subCat = subCatName.toLowerCase();

            this.allCategory = false;

            if (subCat !== "") {
                this.$router
                    .push(
                        "/visualize/contractor/" +
                        this.changeUrlName(parentCat) +
                        "-" +
                        this.changeUrlName(subCat)
                    )
                    .catch(() => { });
            } else {
                this.$router
                    .push(
                        "/visualize/contractor/" + this.changeUrlName(parentCat)
                    )
                    .catch(() => { });
            }
        },
        fetchAllCat(menu) {
            let menuCategory = null;
            console.log("====>>>", menu);
            let parentCatName = menu.name;

            axios
                .get(`/api/menu_category_show_all/${menu.id}`)
                .then(res => {
                    menuCategory = res.data.data;
                    console.log(res.data.data);
                    let categories=[];
                    for (let i = 0; i < menuCategory.length; i++) {
                        const element = menuCategory[i];
                        categories.push(element.category);

                    }
                    var data = {
                        showroom: this.showroomId.showroom,
                        category: menuCategory[0].category_id
                    };

                    this.setTopProduct(data);
                    var subCat = "";
                    window.scrollTo({
                        top: 700,
                        left: 0,
                        behavior: "smooth"
                    });
                    this.updateCategory({
                        parent: parentCatName,
                        sub: "",
                        list: categories,
                        type: "all"
                    });
                    this.updateBreadcrumb({
                        parent: "all "+parentCatName,
                        child: ""
                    });
                    this.updateProductCategory({
                        category_id: menuCategory[0].category.id,
                        category_name: menuCategory[0].category.name
                    });

                    var parentCat = parentCatName.toLowerCase();
                    var subCat = "";

                    this.allCategory = false;
                    if (subCat !== "") {
                        this.$router
                            .push(
                                "/visualize/contractor/" +
                                this.changeUrlName(parentCat) +
                                "-" +
                                this.changeUrlName(subCat)
                            )
                            .catch(() => { });
                    } else {
                        this.$router
                            .push(
                                "/visualize/contractor/all-" + this.changeUrlName(parentCat)
                            )
                            .catch(() => { });
                    }

                })
                .catch(error => {
                    console.log(error);
                });


        },
        async check_validUser() {
            if (localStorage.getItem("authToken")) {
                if (!this.user) {
                    this.getUserData();
                } else {
                    if (
                        this.user.type == "Admin" &&
                        !this.$cookies.get("otp_verify") &&
                        this.$router.history.current.name != "Login"
                    ) {
                        this.logout();
                    }
                    this.$cookies.set("wev_ut", this.user.type, "1d");
                    if (this.user) {
                        this.getCartData();
                        this.getPendingNotifications();
                    }
                    if (
                        !this.user.email_verified_at &&
                        this.$router.history.current.name != "Verify"
                    ) {
                        this.$router.push("/verifiction").catch(() => { });
                    }
                    if (
                        this.user.email_verified_at &&
                        (this.$router.history.current.name == "Verify" ||
                            this.$router.history.current.name == "Verifiction")
                    ) {
                        this.$router
                            .push(this.$route.query.redirect || "/")
                            .catch(() => { });
                    }
                }
            }
        },

        logout() {
            let logout_loader = this.$loading.show({
                opacity: 0.9
            });
            this.sendLogoutRequest().then(() => {
                localStorage.removeItem("my_item");
                localStorage.removeItem("project");
                localStorage.removeItem("visual_redirect");
                localStorage.removeItem("showroom");
                localStorage.removeItem("category");
                localStorage.removeItem("breadcrumb");
                localStorage.removeItem("recently_viewed");
                localStorage.removeItem("showroom");
                localStorage.removeItem("product_category");
                localStorage.removeItem("product_list");
                localStorage.removeItem("customer_viewed");
                localStorage.removeItem("top_product");
                localStorage.removeItem("my_item");
                localStorage.removeItem("new-layout");
                localStorage.removeItem("cart_id");
                this.removeCartData();
                //this.$router.push("/");
                this.$router.push("/").catch(() => { });
                this.checkUserLogin(false);
                logout_loader.hide();
                Toast.fire({
                    icon: "success",
                    title: "Logged Out Successfully"
                });
            });
        },

        showMenu(name) {
            this.currentMenu = name;
            this.show = !this.show ? true : false;
        },
        updateCartItemCount(){
            // this.getCartData();
            console.log("get cart item datas Header")
            if(localStorage.getItem('cart_id')){
            this.getCartData();
        }
        //     let cart_itemsL=localStorage.getItem('cart_item');
        // console.log("=====<>?", cart_itemsL);
        // if(cart_itemsL){
        //     cart_itemsL=JSON.parse(cart_itemsL);
        //     this.cart_items = cart_itemsL.length;
        // }
        }
    }
};
</script>
